import React, { useContext, useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';
import { fetch_dietician_request_list, fetch_stock, update_dietician_request_list } from '../api/api';
import { Link } from 'react-router-dom';
import Loader from '../Loader/Loader';
import { MyContext } from '../context/Context';
import $ from 'jquery';
import { toast } from 'react-toastify';
import api from '../api/url';

function RequestForDietician() {
    const { loader, setLoader } = useContext(MyContext);
    const [userStatus, setUserStatus] = useState([]);

    useEffect(() => {
        fetch_dietician_request_list_api();
    }, []);

    // fetch stock
    const fetch_dietician_request_list_api = async () => {
        setLoader(true);
        try {
            const res = await fetch_dietician_request_list();
            if (res.status === 200) {
                setUserStatus(res.data.data);
                console.log(res.data.data)
            }
            setLoader(false);
        } catch (error) {
            console.error("Error fetching dietician request list", error);
        }
    };


    const handleStatusChange = async (user_id, newStatus) => {

        const updatedStatus = userStatus.map((item) =>
            item.user_id === user_id ? { ...item, status: newStatus } : item
        );
        setUserStatus(updatedStatus);

        const userToUpdate = updatedStatus.find((item) => item.user_id === user_id);

        if (!userToUpdate) {
            console.error(`User with ID ${user_id} not found.`);
            return;
        }

        // setLoader(true);
        try {
            const res = await update_dietician_request_list(userToUpdate);
            if (res.status === 200) {
                toast.success("Status updated successfully");
            }
        } catch (error) {
            console.error("Error updating dietician request status:", error);
        } finally {
            // setLoader(false);
        }
    };


    // data table 
    useEffect(() => {
        const tableId = '#example2';
        const table = $(tableId);

        // Destroy any existing DataTable instance before initializing a new one
        if ($.fn.DataTable.isDataTable(tableId)) {
            table.DataTable().destroy();
        }

        // Initialize DataTable with scrollX for horizontal scrolling
        table.DataTable({
            paging: true,
            lengthChange: true,
            pageLength: 10,
            lengthMenu: [5, 10, 15, 20],
            searching: true,
            ordering: true,
            info: true,
            autoWidth: true,
            infoFiltered: "(filtered from _MAX_ total records)",
            // buttons: ['copy', 'excel', 'pdf', 'print'],
            // dom: 'Bfrtip',
            pagingType: 'full_numbers', // Pagination with full numbers
            language: {
                paginate: {
                    first: '«',
                    last: '»',
                    next: '›',
                    previous: '‹',
                }
            },
            drawCallback: function (settings) {
                const api = this.api();
                const info = api.page.info();
                const $paginate = $(tableId + '_paginate').find('span a.paginate_button');
                const currentPage = info.page;
                const totalPages = info.pages;

                // Show only specific pages with ellipses
                $paginate.each(function (index) {
                    const pageIndex = parseInt($(this).text(), 10) - 1;
                    if (isNaN(pageIndex)) return; // Skip non-number buttons

                    if (
                        pageIndex === 0 ||
                        pageIndex === totalPages - 1 ||
                        (pageIndex >= currentPage - 1 && pageIndex <= currentPage + 1)
                    ) {
                        $(this).show();
                    } else {
                        $(this).hide();
                    }
                });

                // Add ellipses if necessary
                if (currentPage > 2) {
                    $('<span class="paginate_button ellipsis">...</span>').insertAfter($paginate.eq(0));
                }
                if (currentPage < totalPages - 3) {
                    $('<span class="paginate_button ellipsis">...</span>').insertBefore($paginate.eq(totalPages - 1));
                }
            }
        });

        return () => {
            if ($.fn.DataTable.isDataTable(tableId)) {
                table.DataTable().destroy();
            }
        };
    }, [userStatus]);

    return (
        <div className="wrapper">
            <Navbar />
            <Sidebar />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12 d-flex flex-column flex-sm-row justify-content-between">
                                <h1 className="m-0">Request For Dietitian</h1>
                                <span className='text-sm d-flex justify-content-end mt-4 mb-4 mt-sm-0 mb-sm-0'>
                                    <Link to="/dashboard">Dashboard</Link>
                                    <span className='ml-1 mr-1'>/</span>
                                    <span>Request For Dietitian</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    loader ? <Loader /> : (
                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-header">
                                                <h3 className="card-title">Request For Dietitian List</h3>
                                            </div>
                                            <div className="card-body">

                                                <div className='table-responsive'>
                                                    <table id="example2" className="table table-bordered table-hover">
                                                        <thead>
                                                            <tr>
                                                                <th>#</th>
                                                                <th>User Profile</th>
                                                                <th>User Name</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {
                                                                userStatus && userStatus.map((status, index) => (
                                                                    <tr key={index}>
                                                                        <td>{index + 1}</td>
                                                                        <td className=''>
                                                                            <div className="request-for-dietitian">
                                                                                {
                                                                                    status?.user?.user_profile ?
                                                                                        <img
                                                                                            src={`${api.imageUrl}${status?.user?.user_profile}`}
                                                                                            alt="user profile"
                                                                                        />
                                                                                        : <img
                                                                                            src="https://www.pngall.com/wp-content/uploads/5/Profile-Male-PNG-Clipart.png"
                                                                                            alt="user profile"
                                                                                        />
                                                                                }
                                                                            </div>
                                                                        </td>
                                                                        <td>{status?.user?.firstname ? status?.user?.firstname + " " + status?.user?.lastname : " - "}</td>
                                                                        <td style={{ width: "205px" }}>

                                                                            {/* <div className="btn-group">
                                                                                <button type="button" className={`btn btn-naariyal-green dropdown-toggle pr-3 pl-3 bg-${status.status == 1 ? 'success' : 'danger'}`} data-toggle="dropdown">{status.status == 1 ? 'Yes' : 'No'}</button>
                                                                                <div className="dropdown-menu" role="menu">
                                                                                    <Link
                                                                                        className="dropdown-item text-success"
                                                                                    >
                                                                                        <i className="nav-icon fa-solid fa-check mr-2"></i>
                                                                                        Yes
                                                                                    </Link>

                                                                                    <div className="dropdown-divider"></div>

                                                                                    <Link
                                                                                        className="dropdown-item text-danger"
                                                                                    >
                                                                                        <i className="nav-icon fa-solid fa-xmark mr-2"></i>
                                                                                        No
                                                                                    </Link>
                                                                                </div>
                                                                            </div> */}

                                                                            {/* radio button */}
                                                                            <div className="form-group d-flex">
                                                                                <div className="custom-control custom-radio mr-3">
                                                                                    <input
                                                                                        className="custom-control-input"
                                                                                        type="radio"
                                                                                        id={`customRadioYes${index}`}
                                                                                        name={`customRadio${status.user_id}`}
                                                                                        checked={status.status === 1}
                                                                                        onChange={() => handleStatusChange(status.user_id, 1)}
                                                                                    />
                                                                                    <label htmlFor={`customRadioYes${index}`} className="custom-control-label">Assign</label>
                                                                                </div>
                                                                                <div className="custom-control custom-radio">
                                                                                    <input
                                                                                        className="custom-control-input custom-control-input-danger"
                                                                                        type="radio"
                                                                                        id={`customRadioNo${index}`}
                                                                                        name={`customRadio${status.user_id}`}
                                                                                        checked={status.status === 0}
                                                                                        onChange={() => handleStatusChange(status.user_id, 0)}
                                                                                    />
                                                                                    <label htmlFor={`customRadioNo${index}`} className="custom-control-label">Unassign</label>
                                                                                </div>
                                                                            </div>

                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </section>
                    )
                }
            </div>

            <Footer />
            <aside className="control-sidebar control-sidebar-dark"></aside>
        </div>
    );
}

export default RequestForDietician;
